export default __webpack_public_path__ + "static/media/flag-en-IN.9fb3b7ec.png";